import { createSlice } from "@reduxjs/toolkit";

import { blogArticleInitialState } from "./blogArticle.initialState";
import {
  getBlogArticle,
  resetBlogArticleDataLoaded,
  saveServerBlogArticle,
} from "./blogArticle.operations";
import {
  blogArticleFulfilledReducer,
  blogArticlePendingReducer,
  blogArticleRejectedReducer,
  resetBlogArticleDataLoadedReducer,
} from "./blogArticle.reducer";

const blogArticleSlice = createSlice({
  name: "blogArticle",
  initialState: blogArticleInitialState,
  extraReducers: builder =>
    builder
      .addCase(saveServerBlogArticle, blogArticleFulfilledReducer)

      .addCase(getBlogArticle.pending, blogArticlePendingReducer)
      .addCase(getBlogArticle.rejected, blogArticleRejectedReducer)
      .addCase(getBlogArticle.fulfilled, blogArticleFulfilledReducer),
});

export const BlogArticleAction = {
  getBlogArticle,
  saveServerBlogArticle,
};

export default blogArticleSlice.reducer;
